"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Loader = (fn) => fn;
exports.default = Loader;
//# sourceMappingURL=loader.js.map